import React, { useCallback, useEffect } from "react"
import { useLocation } from "react-router-dom"
import qs from "qs"
import { useTrack } from "@hackler/react-sdk"

export function RedirectWithLogging() {
  const track = useTrack()
  const { search } = useLocation()
  const queryString = qs.parse(search, { ignoreQueryPrefix: true })

  const redirectUrl = queryString["redirectUrl"]?.toString()
  const key = queryString["key"]?.toString()?.toLowerCase()

  const pageView = useCallback(() => {
    if (key) {
      track({ key: key })
    }
    if (!redirectUrl) {
      window.location.replace("/")
      return
    }
    window.location.replace(redirectUrl!!)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(pageView, [pageView])

  return (
    <div>
    </div>
  )
}
